import React from 'react';
import { Route } from 'react-router';
import { LoggingRedirect } from './Routes';

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
const ProtectedRoute = ({ loggedIn, component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={({ location }) =>
                loggedIn ? (
                    component
                ) : (
                    <LoggingRedirect
                        origin="PROTECTED"
                        to={{
                            pathname: '/sign-in',
                            state: { from: location },
                        }}
                    />
                )
            }
        />
    );
};

export default ProtectedRoute;
